
export function showConfirm(vm, message, props) {
    return vm.$bvModal.msgBoxConfirm(message, {
        hideHeader: false,
        hideHeaderClose: false,
        headerClass: `border-0 ${!props.title ? 'pb-2' : ''}`,
        bodyClass: !props.title ? 'pt-0' : '',
        footerClass: 'border-0',
        cancelTitle: 'Annuler',
        cancelVariant: 'light',
        buttonSize: 'sm',
        size: 'sm',
        centered: true,
        ...props,
    })
}
